/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./GoldLoanReport.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";

const GoldLoanReport = () => {
  const [loans, setLoans] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [groups, setGroups] = useState([]);
  const [centers, setCenters] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const [filters, setFilters] = useState({
    schemeName: "",
    status: "",
    loanAppliedDate: "",
  });

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchLoanReport = async (page = currentPage) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api//gold-loan/list`,
        {
          params: {
            superAdminId: profile.superAdminId || 14,
            // groupId: selectedGroup?.id,
            // centerId: selectedCenter?.id,
            branchId: profile.id,
            page,
            limit: 10,
          },
        }
      );

      setLoans(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching loan report:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter?.id}`
      );
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://narrowitsolution.in/api/group/centre?LoanofficerId=${profile.id}`
      );
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };


  useEffect(() => {
      fetchLoanReport(currentPage);
  }, [currentPage,profile]);


useEffect(() => {
      fetchLoanReport(currentPage);
  }, []);



  const handleFilter = () => {
    setCurrentPage(1); 
    fetchLoanReport(1);
  };


  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleViewEmi = (loan) =>
    navigate(
      `/grouploan/grouploanreport/GroupLoanEmiDetails/${loan.id}`,
      { state: { loan } }
    );

  const handleViewLoanCard = (loan) =>
    navigate(
      `/grouploan/grouploanreport/GroupLoanEmiCard/${loan.id}`,
      { state: { loan } }
    );

  const filteredLoans = loans.filter((loan) => {
    const schemeMatch =
      !filters.schemeName ||
      loan.schemeName
        ?.toLowerCase()
        .includes(filters.schemeName.toLowerCase());

    const statusMatch =
      !filters.status ||
      loan.status?.toLowerCase() === filters.status.toLowerCase();

    const dateMatch =
      !filters.loanAppliedDate ||
      new Date(loan.loanAppliedDate).toLocaleDateString("en-CA") ===
        filters.loanAppliedDate;

    return schemeMatch && statusMatch && dateMatch;
  });

  if (loading) {
    return (
      <div className="gold-loan-report-loadingWrapper">
        <div className="gold-loan-report-spinner"></div>
        <p>Loading Gold Loan Report...</p>
      </div>
    );
  }

  return (
    <div className="gold-loan-report-app">
      <h2 className="gold-loan-report-title">
         Gold Loan Report
      </h2>

      {/* Filters */}
      {/* <section className="gold-loan-report-filterCard">
        <div className="gold-loan-report-glr-filter">
          <label>Select Collection Landmark</label>
          <select
            onChange={(e) => {
              const center = centers.find(
                (c) => c.id === Number(e.target.value)
              );
              setSelectedCenter(center);
            }}
          >
            <option value="">Select Landmark</option>
            {centers.map((c) => (
              <option key={c.id} value={c.id}>
                {c.CenterName}
              </option>
            ))}
          </select>
        </div>

        <div className="gold-loan-report-glr-filter">
          <label>Select Group Name</label>
          <select
            value={selectedGroup ? selectedGroup.id : ""}
            onChange={(e) => {
              const group = groups.find(
                (g) => g.id === Number(e.target.value)
              );
              setSelectedGroup(group);
            }}
          >
            <option value="">Select Group Name</option>
            {groups.map((gn) => (
              <option key={gn.id} value={gn.id}>
                {gn.groupname}, {gn.groupcode}
              </option>
            ))}
          </select>
        </div>

        <button
          className="gold-loan-report-submit-btn"
          onClick={handleFilter}
        >
          Submit
        </button>
      </section> */}

         <div className="gold-loan-report-filterCard">
        <input
          type="text"
          className="filterInput"
          placeholder="🔎 Filter by Scheme"
          value={filters.schemeName}
          onChange={(e) => handleFilterChange("schemeName", e.target.value)}
        />
        <select
          className="filterSelect"
          value={filters.status}
          onChange={(e) => handleFilterChange("status", e.target.value)}
        >
          <option value="">All Status</option>
          <option value="ACTIVE">ACTIVE</option>
          <option value="pending">pending</option>
          <option value="rejected">Rejected</option>
        </select>
        <input
          type="date"
          className="filterInput"
          value={filters.loanAppliedDate}
          onChange={(e) => handleFilterChange("loanAppliedDate", e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="gold-loan-report-tableWrapper">
        <table className="gold-loan-report-table">
          <thead>
            <tr>
              <th>Account No</th>
              <th>Loan Amount</th>
              <th>Customer Name</th>
              <th>Status</th>
              <th>View EMI</th>
              <th>Loan Card</th>
            </tr>
          </thead>
          <tbody>
            {filteredLoans.length > 0 ? (
              filteredLoans.map((item) => (
                <tr key={item.id}>
                  <td>{item.loanAccountNumber}</td>
                  <td>{item.loanAmount}</td>
                  <td>{item.userName}</td>
                  <td>{item.status}</td>
                  <td>
                    {item.status.toLowerCase() === "active" ? (
                      <button
                        className="gold-loan-report-btn-view"
                        onClick={() => handleViewEmi(item)}
                      >
                        <FaRupeeSign />
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {item.status.toLowerCase() === "active" ? (
                      <button
                        className="gold-loan-report-btn-card"
                        onClick={() => handleViewLoanCard(item)}
                      >
                        Loan Card
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="gold-loan-report-pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default GoldLoanReport;
